import React from 'react';

const RequestContext = React.createContext({
  request: {},
  requestData: {},
  updateRequestData: () => {},
});

export default RequestContext;
